import axios from "../../utils/axios";

export type TabDecisionStateResponse = {
    isReadonly: boolean;
    readonlyReason: string;
}

export const getTabDecisionState = (rfpId: string) => axios
    .get(`/api/v1/frontend/tenders/facility-manager/${ rfpId }/tab-decision-state`)
    .then((response: { data: { data: TabDecisionStateResponse } }) => response.data.data)
